import { useState } from "react";
import { createPortal } from "react-dom";
import { useAuth } from "../contexts/AuthContext";

function LogoutButton({ closeMenu }) {
  const { logout, loggingOut } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (closeMenu) closeMenu();
    setShowModal(true);
  };

  const confirmLogout = async () => {
    await logout();
    setShowModal(false);
  };

  const cancelLogout = () => setShowModal(false);

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loggingOut}
        className={`logout-btn ${loggingOut ? "disabled" : ""}`}
      >
        {loggingOut ? "Logging out..." : "Logout"}
      </button>

      {showModal &&
        createPortal(
          <>
            {/* Backdrop */}
            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1040 }}
              onClick={cancelLogout}
            />

            {/* Modal */}
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
              style={{ zIndex: 1050 }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Logout</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={cancelLogout}
                    />
                  </div>
                  <div className="modal-body">
                    <p>Are you sure you want to log out?</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={cancelLogout}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={confirmLogout}
                      disabled={loggingOut}
                    >
                      {loggingOut ? "Logging out…" : "Logout"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>,
          document.body
        )}
    </>
  );
}

export default LogoutButton;
